import { render } from "./BusinessPayments.vue?vue&type=template&id=1648c475&scoped=true"
import script from "./BusinessPayments.vue?vue&type=script&lang=js"
export * from "./BusinessPayments.vue?vue&type=script&lang=js"

import "./BusinessPayments.vue?vue&type=style&index=0&id=1648c475&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1648c475"]])

export default __exports__